module.exports = __webpack_public_path__ + "static/media/office-blue-map.66a86e1c.png";